const DAMSVG = {
  folderIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 20 16" fill="none">
      <path
        d="M2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H7.175C7.44167 0 7.69583 0.05 7.9375 0.15C8.17917 0.25 8.39167 0.391667 8.575 0.575L10 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H2Z"
        fill="#753cb7"
      />
    </svg>
  ),
  moreVertSvg: (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <mask id="mask0_6501_8971" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
        <rect x="0.414978" y="0.667969" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6501_8971)">
        <path
          d="M12.415 19.9369C12.0025 19.9369 11.6494 19.79 11.3557 19.4962C11.0619 19.2025 10.915 18.8494 10.915 18.4369C10.915 18.0244 11.0619 17.6713 11.3557 17.3774C11.6494 17.0838 12.0025 16.9369 12.415 16.9369C12.8275 16.9369 13.1806 17.0838 13.4742 17.3774C13.7681 17.6713 13.915 18.0244 13.915 18.4369C13.915 18.8494 13.7681 19.2025 13.4742 19.4962C13.1806 19.79 12.8275 19.9369 12.415 19.9369ZM12.415 14.1677C12.0025 14.1677 11.6494 14.0208 11.3557 13.7269C11.0619 13.4333 10.915 13.0802 10.915 12.6677C10.915 12.2552 11.0619 11.9021 11.3557 11.6084C11.6494 11.3146 12.0025 11.1677 12.415 11.1677C12.8275 11.1677 13.1806 11.3146 13.4742 11.6084C13.7681 11.9021 13.915 12.2552 13.915 12.6677C13.915 13.0802 13.7681 13.4333 13.4742 13.7269C13.1806 14.0208 12.8275 14.1677 12.415 14.1677ZM12.415 8.39844C12.0025 8.39844 11.6494 8.2516 11.3557 7.95794C11.0619 7.6641 10.915 7.31094 10.915 6.89844C10.915 6.48594 11.0619 6.13285 11.3557 5.83919C11.6494 5.54535 12.0025 5.39844 12.415 5.39844C12.8275 5.39844 13.1806 5.54535 13.4742 5.83919C13.7681 6.13285 13.915 6.48594 13.915 6.89844C13.915 7.31094 13.7681 7.6641 13.4742 7.95794C13.1806 8.2516 12.8275 8.39844 12.415 8.39844Z"
          fill="#fdfdfd"
        />
      </g>
    </svg>
  ),
  moreVertSvgBlack: (
    <svg xmlns="http://www.w3.org/2000/svg" width="3" height="16" viewBox="0 0 3 16" fill="none">
      <path
        d="M1.5 15.269C1.0875 15.269 0.734417 15.1221 0.44075 14.8282C0.146917 14.5346 0 14.1815 0 13.769C0 13.3565 0.146917 13.0033 0.44075 12.7095C0.734417 12.4158 1.0875 12.269 1.5 12.269C1.9125 12.269 2.26558 12.4158 2.55925 12.7095C2.85308 13.0033 3 13.3565 3 13.769C3 14.1815 2.85308 14.5346 2.55925 14.8282C2.26558 15.1221 1.9125 15.269 1.5 15.269ZM1.5 9.49972C1.0875 9.49972 0.734417 9.3528 0.44075 9.05897C0.146917 8.7653 0 8.41222 0 7.99972C0 7.58722 0.146917 7.23414 0.44075 6.94047C0.734417 6.64664 1.0875 6.49972 1.5 6.49972C1.9125 6.49972 2.26558 6.64664 2.55925 6.94047C2.85308 7.23414 3 7.58722 3 7.99972C3 8.41222 2.85308 8.7653 2.55925 9.05897C2.26558 9.3528 1.9125 9.49972 1.5 9.49972ZM1.5 3.73047C1.0875 3.73047 0.734417 3.58364 0.44075 3.28997C0.146917 2.99614 0 2.64297 0 2.23047C0 1.81797 0.146917 1.46489 0.44075 1.17122C0.734417 0.877386 1.0875 0.730469 1.5 0.730469C1.9125 0.730469 2.26558 0.877386 2.55925 1.17122C2.85308 1.46489 3 1.81797 3 2.23047C3 2.64297 2.85308 2.99614 2.55925 3.28997C2.26558 3.58364 1.9125 3.73047 1.5 3.73047Z"
        fill="#1C1B1F"
      />
    </svg>
  ),
  closedFolder: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#753cb7"
    >
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#753cb7" />
      </mask>
      <g mask="url(#mask0_210_1045)">
        <path
          d="M4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H9.798L11.798 6.5H19.6923C20.1974 6.5 20.625 6.675 20.975 7.025C21.325 7.375 21.5 7.80258 21.5 8.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775ZM4.30775 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V8.30775C20 8.21792 19.9712 8.14417 19.9135 8.0865C19.8558 8.02883 19.7821 8 19.6923 8H11.1845L9.1845 6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18Z"
          fill="#1E293B"
        />
      </g>
    </svg>
  ),
  openFolder: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="#753cb7"
    >
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
        <rect x="0.93335" y="0.382812" width="24" height="24" fill="#753cb7" />
      </mask>
      <g mask="url(#mask0_210_1039)">
        <path
          d="M5.18335 19.8828C4.69752 19.8828 4.28435 19.7126 3.94385 19.3723C3.60352 19.0318 3.43335 18.6186 3.43335 18.1328V6.69056C3.43335 6.20473 3.61318 5.78198 3.97285 5.42231C4.33252 5.06265 4.75527 4.88281 5.2411 4.88281H10.7313L12.7313 6.88281H20.6256C21.0731 6.88281 21.459 7.0274 21.7833 7.31656C22.1077 7.60556 22.2955 7.96098 22.3468 8.38281H12.1179L10.1178 6.38281H5.2411C5.15127 6.38281 5.07752 6.41165 5.01985 6.46931C4.96218 6.52698 4.93335 6.60073 4.93335 6.69056V18.0751C4.93335 18.1456 4.95102 18.2032 4.98635 18.2481C5.02152 18.2931 5.06793 18.3316 5.1256 18.3636L7.45835 10.5751H24.1161L21.6949 18.6406C21.5807 19.0161 21.3669 19.317 21.0536 19.5433C20.7401 19.7696 20.3924 19.8828 20.0104 19.8828H5.18335ZM6.69685 18.3828H20.2026L22.0891 12.0751H8.58335L6.69685 18.3828Z"
          fill="#1E293B"
        />
      </g>
    </svg>
  ),
  keyBoardArrowRightIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <mask id="mask0_233_1614" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
        <rect x="0.415771" y="0.84375" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_233_1614)">
        <path
          d="M13.362 12.8437L8.76196 8.24369L9.81571 7.18994L15.4695 12.8437L9.81571 18.4974L8.76196 17.4437L13.362 12.8437Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  ),
  keyBoardArrowLeftIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_233_1620" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_233_1620)">
        <path
          d="M11.9999 15.0537L6.34619 9.39994L7.39994 8.34619L11.9999 12.9462L16.5999 8.34619L17.6537 9.39994L11.9999 15.0537Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  ),
  filterIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 25 25" fill="none">
      <mask id="mask0_2102_14164" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
        <rect x="0.871094" y="0.201172" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2102_14164)">
        <path
          d="M12.255 19.7012C12.0037 19.7012 11.7934 19.6165 11.6243 19.4472C11.4549 19.278 11.3703 19.0678 11.3703 18.8164V13.0282L5.77226 5.91667C5.57992 5.66017 5.55201 5.39351 5.68851 5.11667C5.82517 4.83967 6.05567 4.70117 6.38001 4.70117H19.3605C19.6848 4.70117 19.9153 4.83967 20.052 5.11667C20.1885 5.39351 20.1606 5.66017 19.9683 5.91667L14.3703 13.0282V18.8164C14.3703 19.0678 14.2856 19.278 14.1163 19.4472C13.9471 19.6165 13.7368 19.7012 13.4855 19.7012H12.255Z"
          fill="#753cb7"
        />
      </g>
    </svg>
  ),
  gridViewIcons: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M2 8C1.45 8 0.979 7.804 0.587 7.412C0.195667 7.02067 0 6.55 0 6V2C0 1.45 0.195667 0.979 0.587 0.587C0.979 0.195667 1.45 0 2 0H6C6.55 0 7.021 0.195667 7.413 0.587C7.80433 0.979 8 1.45 8 2V6C8 6.55 7.80433 7.02067 7.413 7.412C7.021 7.804 6.55 8 6 8H2ZM2 18C1.45 18 0.979 17.8043 0.587 17.413C0.195667 17.021 0 16.55 0 16V12C0 11.45 0.195667 10.979 0.587 10.587C0.979 10.1957 1.45 10 2 10H6C6.55 10 7.021 10.1957 7.413 10.587C7.80433 10.979 8 11.45 8 12V16C8 16.55 7.80433 17.021 7.413 17.413C7.021 17.8043 6.55 18 6 18H2ZM12 8C11.45 8 10.9793 7.804 10.588 7.412C10.196 7.02067 10 6.55 10 6V2C10 1.45 10.196 0.979 10.588 0.587C10.9793 0.195667 11.45 0 12 0H16C16.55 0 17.021 0.195667 17.413 0.587C17.8043 0.979 18 1.45 18 2V6C18 6.55 17.8043 7.02067 17.413 7.412C17.021 7.804 16.55 8 16 8H12ZM12 18C11.45 18 10.9793 17.8043 10.588 17.413C10.196 17.021 10 16.55 10 16V12C10 11.45 10.196 10.979 10.588 10.587C10.9793 10.1957 11.45 10 12 10H16C16.55 10 17.021 10.1957 17.413 10.587C17.8043 10.979 18 11.45 18 12V16C18 16.55 17.8043 17.021 17.413 17.413C17.021 17.8043 16.55 18 16 18H12ZM2 6H6V2H2V6ZM12 6H16V2H12V6ZM12 16H16V12H12V16ZM2 16H6V12H2V16Z"
        fill="#753cb7"
      />
    </svg>
  ),
  listViewIcons: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M16 16V13H2V16H16ZM16 11V7H2V11H16ZM16 5V2H2V5H16ZM2 18C1.45 18 0.979 17.8043 0.587 17.413C0.195667 17.021 0 16.55 0 16V2C0 1.45 0.195667 0.979 0.587 0.587C0.979 0.195667 1.45 0 2 0H16C16.55 0 17.021 0.195667 17.413 0.587C17.8043 0.979 18 1.45 18 2V16C18 16.55 17.8043 17.021 17.413 17.413C17.021 17.8043 16.55 18 16 18H2Z"
        fill="#753cb7"
      />
    </svg>
  ),
  masoNaryViewIcons: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25 25" fill="none">
      <mask
        id="mask0_2108_14617"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="25"
      >
        <rect x="0.923828" y="0.0859375" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2108_14617)">
        <path
          d="M16.0201 19.5859V13.1822H22.4238V19.5859H16.0201ZM12.0201 10.9897V4.58594H22.4238V10.9897H12.0201ZM3.42383 19.5859V13.1822H13.8276V19.5859H3.42383ZM3.42383 10.9897V4.58594H9.82758V10.9897H3.42383ZM13.5198 9.48994H20.9238V6.08594H13.5198V9.48994ZM4.92383 18.0859H12.3278V14.6819H4.92383V18.0859ZM17.5198 18.0859H20.9238V14.6819H17.5198V18.0859ZM4.92383 9.48994H8.32783V6.08594H4.92383V9.48994Z"
          fill="#753cb7"
        />
      </g>
    </svg>
  ),
  folderinlargeViewIcons: (
    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4.25L0.25 0.5H7.75L4 4.25Z" fill="#1E293B" />
    </svg>
  ),
  selectedFoldeSvgIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" fill="none">
      <path
        d="M2.1875 11.625C1.82313 11.625 1.51325 11.4974 1.25787 11.2421C1.00262 10.9868 0.875 10.6769 0.875 10.3125V1.73081C0.875 1.36644 1.00988 1.04938 1.27963 0.779625C1.54938 0.509875 1.86644 0.375 2.23081 0.375H6.3485L7.8485 1.875H13.7692C14.1048 1.875 14.3942 1.98344 14.6375 2.20031C14.8808 2.41706 15.0216 2.68362 15.0601 3H7.38838L5.88838 1.5H2.23081C2.16344 1.5 2.10813 1.52163 2.06488 1.56488C2.02163 1.60813 2 1.66344 2 1.73081V10.2692C2 10.3221 2.01325 10.3653 2.03975 10.3989C2.06612 10.4327 2.10094 10.4616 2.14419 10.4856L3.89375 4.64419H16.3871L14.5711 10.6933C14.4855 10.9749 14.3252 11.2006 14.0902 11.3704C13.8551 11.5401 13.5943 11.625 13.3078 11.625H2.1875ZM3.32262 10.5H13.4519L14.8668 5.76919H4.7375L3.32262 10.5Z"
        fill="#1C1B1F"
      />
    </svg>
  ),
  folderSvgIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" fill="none">
      <path
        d="M2.1875 11.625C1.82313 11.625 1.51325 11.4974 1.25787 11.2421C1.00262 10.9868 0.875 10.6769 0.875 10.3125V1.73081C0.875 1.36644 1.00988 1.04938 1.27963 0.779625C1.54938 0.509875 1.86644 0.375 2.23081 0.375H6.3485L7.8485 1.875H13.7692C14.1048 1.875 14.3942 1.98344 14.6375 2.20031C14.8808 2.41706 15.0216 2.68362 15.0601 3H7.38838L5.88838 1.5H2.23081C2.16344 1.5 2.10813 1.52163 2.06488 1.56488C2.02163 1.60813 2 1.66344 2 1.73081V10.2692C2 10.3221 2.01325 10.3653 2.03975 10.3989C2.06612 10.4327 2.10094 10.4616 2.14419 10.4856L3.89375 4.64419H16.3871L14.5711 10.6933C14.4855 10.9749 14.3252 11.2006 14.0902 11.3704C13.8551 11.5401 13.5943 11.625 13.3078 11.625H2.1875ZM3.32262 10.5H13.4519L14.8668 5.76919H4.7375L3.32262 10.5Z"
        fill="#929292"
      />
    </svg>
  ),
  googleLensIconSvg: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="Gdd5U"
      focusable="false"
      viewBox="0 0 192 192"
      width="192"
      height="192"
    >
      <rect fill="none" height="192" width="192" />
      <g>
        <circle fill="#34A853" cx="144.07" cy="144" r="16" />
        <circle fill="#4285F4" cx="96.07" cy="104" r="24" />
        <path
          fill="#EA4335"
          d="M24,135.2c0,18.11,14.69,32.8,32.8,32.8H96v-16l-40.1-0.1c-8.8,0-15.9-8.19-15.9-17.9v-18H24V135.2z"
        />
        <path
          fill="#FBBC05"
          d="M168,72.8c0-18.11-14.69-32.8-32.8-32.8H116l20,16c8.8,0,16,8.29,16,18v30h16V72.8z"
        />
        <path
          fill="#4285F4"
          d="M112,24l-32,0L68,40H56.8C38.69,40,24,54.69,24,72.8V92h16V74c0-9.71,7.2-18,16-18h80L112,24z"
        />
      </g>
    </svg>
  ),
};

export const SVG = {
  ...DAMSVG,
  Correct: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_967_8953" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_967_8953)">
        <path d="M7.16224 11.3741L13.6224 4.91402C13.785 4.75239 13.9752 4.67039 14.1929 4.66802C14.4106 4.66564 14.6026 4.74633 14.7689 4.91008C14.9353 5.07371 15.0185 5.26358 15.0185 5.47971C15.0185 5.69583 14.9353 5.88708 14.7689 6.05346L7.80555 13.0097C7.62218 13.1952 7.4083 13.288 7.16393 13.288C6.91955 13.288 6.70455 13.1952 6.51893 13.0097L3.27518 9.76596C3.11368 9.60771 3.03368 9.41983 3.03518 9.20233C3.03655 8.98483 3.11911 8.79289 3.28286 8.62652C3.44649 8.46014 3.63636 8.37696 3.85249 8.37696C4.06861 8.37696 4.25986 8.46014 4.42624 8.62652L7.16224 11.3741Z" fill="#00841D" />
      </g>
    </svg>
  ),
  Wrong: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_963_8893" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_963_8893)">
        <path d="M8.9994 9.7902L5.19465 13.5951C5.09077 13.6989 4.96021 13.752 4.80296 13.7545C4.64584 13.7569 4.5129 13.7038 4.40415 13.5951C4.29552 13.4864 4.24121 13.3546 4.24121 13.1999C4.24121 13.0451 4.29552 12.9134 4.40415 12.8046L8.20909 8.99989L4.40415 5.19514C4.3004 5.09126 4.24727 4.9607 4.24477 4.80345C4.2424 4.64632 4.29552 4.51339 4.40415 4.40464C4.5129 4.29601 4.64465 4.2417 4.7994 4.2417C4.95415 4.2417 5.0859 4.29601 5.19465 4.40464L8.9994 8.20957L12.8041 4.40464C12.908 4.30089 13.0386 4.24776 13.1958 4.24526C13.353 4.24289 13.4859 4.29601 13.5947 4.40464C13.7033 4.51339 13.7576 4.64514 13.7576 4.79989C13.7576 4.95464 13.7033 5.08639 13.5947 5.19514L9.78971 8.99989L13.5947 12.8046C13.6984 12.9085 13.7515 13.0391 13.754 13.1963C13.7564 13.3535 13.7033 13.4864 13.5947 13.5951C13.4859 13.7038 13.3541 13.7581 13.1994 13.7581C13.0447 13.7581 12.9129 13.7038 12.8041 13.5951L8.9994 9.7902Z" fill="#830000" />
      </g>
    </svg>
  ),
  cross: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_3863_34640" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="white" />
      </mask>
      <g mask="url(#mask0_3863_34640)">
        <path
          d="M11.9969 13.4008L7.09687 18.3008C6.91354 18.4841 6.68021 18.5758 6.39687 18.5758C6.11354 18.5758 5.88021 18.4841 5.69687 18.3008C5.51354 18.1174 5.42188 17.8841 5.42188 17.6008C5.42188 17.3174 5.51354 17.0841 5.69687 16.9008L10.5969 12.0008L5.69687 7.10078C5.51354 6.91745 5.42188 6.68411 5.42188 6.40078C5.42188 6.11745 5.51354 5.88411 5.69687 5.70078C5.88021 5.51745 6.11354 5.42578 6.39687 5.42578C6.68021 5.42578 6.91354 5.51745 7.09687 5.70078L11.9969 10.6008L16.8969 5.70078C17.0802 5.51745 17.3135 5.42578 17.5969 5.42578C17.8802 5.42578 18.1135 5.51745 18.2969 5.70078C18.4802 5.88411 18.5719 6.11745 18.5719 6.40078C18.5719 6.68411 18.4802 6.91745 18.2969 7.10078L13.3969 12.0008L18.2969 16.9008C18.4802 17.0841 18.5719 17.3174 18.5719 17.6008C18.5719 17.8841 18.4802 18.1174 18.2969 18.3008C18.1135 18.4841 17.8802 18.5758 17.5969 18.5758C17.3135 18.5758 17.0802 18.4841 16.8969 18.3008L11.9969 13.4008Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  hamburger: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_3865_33357" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3865_33357)">
        <path
          d="M4 17.625C3.78333 17.625 3.60433 17.5543 3.463 17.413C3.321 17.271 3.25 17.0917 3.25 16.875C3.25 16.675 3.321 16.5 3.463 16.35C3.60433 16.2 3.78333 16.125 4 16.125H20C20.2167 16.125 20.396 16.2 20.538 16.35C20.6793 16.5 20.75 16.675 20.75 16.875C20.75 17.0917 20.6793 17.271 20.538 17.413C20.396 17.5543 20.2167 17.625 20 17.625H4ZM4 12.75C3.78333 12.75 3.60433 12.679 3.463 12.537C3.321 12.3957 3.25 12.2167 3.25 12C3.25 11.7833 3.321 11.604 3.463 11.462C3.60433 11.3207 3.78333 11.25 4 11.25H20C20.2167 11.25 20.396 11.3207 20.538 11.462C20.6793 11.604 20.75 11.7833 20.75 12C20.75 12.2167 20.6793 12.3957 20.538 12.537C20.396 12.679 20.2167 12.75 20 12.75H4ZM4 7.875C3.78333 7.875 3.60433 7.8 3.463 7.65C3.321 7.5 3.25 7.325 3.25 7.125C3.25 6.90833 3.321 6.72933 3.463 6.588C3.60433 6.446 3.78333 6.375 4 6.375H20C20.2167 6.375 20.396 6.446 20.538 6.588C20.6793 6.72933 20.75 6.90833 20.75 7.125C20.75 7.325 20.6793 7.5 20.538 7.65C20.396 7.8 20.2167 7.875 20 7.875H4Z"
          fill="#1E293B"
        />
      </g>
    </svg>
  ),
  Downarrow: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_4009_29027" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect x="24" width="24" height="24" transform="rotate(90 24 0)" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4009_29027)">
        <path
          d="M9.22933 11.7C8.90918 11.3833 8.83774 11.021 9.015 10.613C9.19158 10.2043 9.50735 10 9.96229 10L15.1689 10C15.6238 10 15.9396 10.2043 16.1162 10.613C16.2934 11.021 16.222 11.3833 15.9019 11.7L13.2733 14.3C13.1722 14.4 13.0627 14.475 12.9447 14.525C12.8268 14.575 12.7004 14.6 12.5656 14.6C12.4308 14.6 12.3044 14.575 12.1865 14.525C12.0685 14.475 11.959 14.4 11.8579 14.3L9.22933 11.7Z"
          fill="#929292"
        />
      </g>
    </svg>
  ),
  DownarrowHover: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_156_36385" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_156_36385)">
        <path d="M11.7 14.7707C11.3833 15.0908 11.021 15.1623 10.613 14.985C10.2043 14.8084 10 14.4927 10 14.0377L10 8.83111C10 8.37617 10.2043 8.0604 10.613 7.88382C11.021 7.70656 11.3833 7.778 11.7 8.09815L14.3 10.7267C14.4 10.8278 14.475 10.9373 14.525 11.0553C14.575 11.1732 14.6 11.2996 14.6 11.4344C14.6 11.5692 14.575 11.6956 14.525 11.8135C14.475 11.9315 14.4 12.041 14.3 12.1421L11.7 14.7707Z" fill="#1E293B" />
      </g>
    </svg>


  ),
  rightarrow: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_4019_16721" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4019_16721)">
        <path
          d="M11.7 14.7707C11.3833 15.0908 11.021 15.1623 10.613 14.985C10.2043 14.8084 10 14.4927 10 14.0377L10 8.83111C10 8.37617 10.2043 8.0604 10.613 7.88382C11.021 7.70656 11.3833 7.778 11.7 8.09815L14.3 10.7267C14.4 10.8278 14.475 10.9373 14.525 11.0553C14.575 11.1732 14.6 11.2996 14.6 11.4344C14.6 11.5692 14.575 11.6956 14.525 11.8135C14.475 11.9315 14.4 12.041 14.3 12.1421L11.7 14.7707Z"
          fill="#929292"
        />
      </g>
    </svg>
  ),
  document: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_247_38638" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_247_38638)">
        <path
          d="M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H13.175C13.4417 2 13.6958 2.05 13.9375 2.15C14.1792 2.25 14.3917 2.39167 14.575 2.575L19.425 7.425C19.6083 7.60833 19.75 7.82083 19.85 8.0625C19.95 8.30417 20 8.55833 20 8.825V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 8C13 8.28333 13.0958 8.52083 13.2875 8.7125C13.4792 8.90417 13.7167 9 14 9H18L13 4V8ZM10.925 15.125L9.525 13.725C9.425 13.625 9.31667 13.55 9.2 13.5C9.08333 13.45 8.9625 13.425 8.8375 13.425C8.7125 13.425 8.5875 13.45 8.4625 13.5C8.3375 13.55 8.225 13.625 8.125 13.725C7.925 13.925 7.825 14.1625 7.825 14.4375C7.825 14.7125 7.925 14.95 8.125 15.15L10.25 17.3C10.35 17.4 10.4583 17.4708 10.575 17.5125C10.6917 17.5542 10.8167 17.575 10.95 17.575C11.0833 17.575 11.2083 17.5542 11.325 17.5125C11.4417 17.4708 11.55 17.4 11.65 17.3L15.875 13.075C16.075 12.875 16.175 12.6333 16.175 12.35C16.175 12.0667 16.075 11.825 15.875 11.625C15.675 11.425 15.4333 11.325 15.15 11.325C14.8667 11.325 14.625 11.425 14.425 11.625L10.925 15.125Z"
          fill="#45A076"
        />
      </g>
    </svg>
  ),
  addproductbutton: (
    <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="none">
      <g filter="url(#filter0_d_4118_60845)">
        <rect
          x="10"
          y="10"
          width="38"
          height="38"
          rx="19"
          fill="white"
          fill-opacity="0.5"
          shape-rendering="crispEdges"
        />
        <circle cx="29" cy="29" r="11" fill="#88A4EA" fill-opacity="0.95" />
        <rect
          x="10.5"
          y="10.5"
          width="37"
          height="37"
          rx="18.5"
          stroke="#E6E6E6"
          shape-rendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4118_60845"
          x="0"
          y="0"
          width="58"
          height="58"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4118_60845" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4118_60845"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  rightarrowCollateral: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="#FFFFFF" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#E6E6E6" />
      <mask id="mask0_2092_57258" maskUnits="userSpaceOnUse" x="4" y="4" width="24" height="24">
        <rect x="28" y="28" width="24" height="24" transform="rotate(-180 28 28)" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2092_57258)">
        <path d="M14.6992 10.6953L19.2992 15.2953C19.3992 15.3953 19.4701 15.5036 19.5117 15.6203C19.5534 15.737 19.5742 15.862 19.5742 15.9953C19.5742 16.1286 19.5534 16.2536 19.5117 16.3703C19.4701 16.487 19.3992 16.5953 19.2992 16.6953L14.6992 21.2953C14.5159 21.4786 14.2826 21.5703 13.9992 21.5703C13.7159 21.5703 13.4826 21.4786 13.2992 21.2953C13.1159 21.112 13.0242 20.8786 13.0242 20.5953C13.0242 20.312 13.1159 20.0786 13.2992 19.8953L17.1992 15.9953L13.2992 12.0953C13.1159 11.912 13.0242 11.6786 13.0242 11.3953C13.0242 11.112 13.1159 10.8786 13.2992 10.6953C13.4826 10.512 13.7159 10.4203 13.9992 10.4203C14.2826 10.4203 14.5159 10.512 14.6992 10.6953Z" fill="#1E293B" />
      </g>
    </svg>
  ),
  rightarrowHover: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="#F2F2F2" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#E6E6E6" />
      <mask id="mask0_2092_57254" maskUnits="userSpaceOnUse" x="4" y="4" width="24" height="24">
        <rect x="28" y="28" width="24" height="24" transform="rotate(180 28 28)" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2092_57254)">
        <path d="M14.6992 10.7031L19.2992 15.3031C19.3992 15.4031 19.4701 15.5115 19.5117 15.6281C19.5534 15.7448 19.5742 15.8698 19.5742 16.0031C19.5742 16.1365 19.5534 16.2615 19.5117 16.3781C19.4701 16.4948 19.3992 16.6031 19.2992 16.7031L14.6992 21.3031C14.5159 21.4865 14.2826 21.5781 13.9992 21.5781C13.7159 21.5781 13.4826 21.4865 13.2992 21.3031C13.1159 21.1198 13.0242 20.8865 13.0242 20.6031C13.0242 20.3198 13.1159 20.0865 13.2992 19.9031L17.1992 16.0031L13.2992 12.1031C13.1159 11.9198 13.0242 11.6865 13.0242 11.4031C13.0242 11.1198 13.1159 10.8865 13.2992 10.7031C13.4826 10.5198 13.7159 10.4281 13.9992 10.4281C14.2826 10.4281 14.5159 10.5198 14.6992 10.7031Z" fill="#929292" />
      </g>
    </svg>
  ),
  leftarrowCollateral: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="#FFFFFF" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#E6E6E6" />
      <mask id="mask0_1168_43000" maskUnits="userSpaceOnUse" x="4" y="4" width="24" height="24">
        <rect x="4" y="4" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1168_43000)">
        <path d="M17.3008 21.2969L12.7008 16.6969C12.6008 16.5969 12.5299 16.4885 12.4883 16.3719C12.4466 16.2552 12.4258 16.1302 12.4258 15.9969C12.4258 15.8635 12.4466 15.7385 12.4883 15.6219C12.5299 15.5052 12.6008 15.3969 12.7008 15.2969L17.3008 10.6969C17.4841 10.5135 17.7174 10.4219 18.0008 10.4219C18.2841 10.4219 18.5174 10.5135 18.7008 10.6969C18.8841 10.8802 18.9758 11.1135 18.9758 11.3969C18.9758 11.6802 18.8841 11.9135 18.7008 12.0969L14.8008 15.9969L18.7008 19.8969C18.8841 20.0802 18.9758 20.3135 18.9758 20.5969C18.9758 20.8802 18.8841 21.1135 18.7008 21.2969C18.5174 21.4802 18.2841 21.5719 18.0008 21.5719C17.7174 21.5719 17.4841 21.4802 17.3008 21.2969Z" fill="#1E293B" />
      </g>
    </svg>

  ),
  leftarrowHover: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="#F2F2F2" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#E6E6E6" />
      <mask id="mask0_1168_42970" maskUnits="userSpaceOnUse" x="4" y="4" width="24" height="24">
        <rect x="4" y="4" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1168_42970)">
        <path d="M17.3008 21.2969L12.7008 16.6969C12.6008 16.5969 12.5299 16.4885 12.4883 16.3719C12.4466 16.2552 12.4258 16.1302 12.4258 15.9969C12.4258 15.8635 12.4466 15.7385 12.4883 15.6219C12.5299 15.5052 12.6008 15.3969 12.7008 15.2969L17.3008 10.6969C17.4841 10.5135 17.7174 10.4219 18.0008 10.4219C18.2841 10.4219 18.5174 10.5135 18.7008 10.6969C18.8841 10.8802 18.9758 11.1135 18.9758 11.3969C18.9758 11.6802 18.8841 11.9135 18.7008 12.0969L14.8008 15.9969L18.7008 19.8969C18.8841 20.0802 18.9758 20.3135 18.9758 20.5969C18.9758 20.8802 18.8841 21.1135 18.7008 21.2969C18.5174 21.4802 18.2841 21.5719 18.0008 21.5719C17.7174 21.5719 17.4841 21.4802 17.3008 21.2969Z" fill="#929292" />
      </g>
    </svg>

  ),
  edit: (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 21.0016C1.45 21.0016 0.979167 20.8057 0.5875 20.4141C0.195833 20.0224 0 19.5516 0 19.0016V5.00156C0 4.45156 0.195833 3.98073 0.5875 3.58906C0.979167 3.1974 1.45 3.00156 2 3.00156H8.525C8.85833 3.00156 9.10833 3.10573 9.275 3.31406C9.44167 3.5224 9.525 3.75156 9.525 4.00156C9.525 4.25156 9.4375 4.48073 9.2625 4.68906C9.0875 4.8974 8.83333 5.00156 8.5 5.00156H2V19.0016H16V12.4766C16 12.1432 16.1042 11.8932 16.3125 11.7266C16.5208 11.5599 16.75 11.4766 17 11.4766C17.25 11.4766 17.4792 11.5599 17.6875 11.7266C17.8958 11.8932 18 12.1432 18 12.4766V19.0016C18 19.5516 17.8042 20.0224 17.4125 20.4141C17.0208 20.8057 16.55 21.0016 16 21.0016H2ZM6 14.0016V11.5766C6 11.3099 6.05 11.0557 6.15 10.8141C6.25 10.5724 6.39167 10.3599 6.575 10.1766L15.175 1.57656C15.375 1.37656 15.6 1.22656 15.85 1.12656C16.1 1.02656 16.35 0.976562 16.6 0.976562C16.8667 0.976562 17.1208 1.02656 17.3625 1.12656C17.6042 1.22656 17.825 1.37656 18.025 1.57656L19.425 3.00156C19.6083 3.20156 19.75 3.4224 19.85 3.66406C19.95 3.90573 20 4.15156 20 4.40156C20 4.65156 19.9542 4.8974 19.8625 5.13906C19.7708 5.38073 19.625 5.60156 19.425 5.80156L10.825 14.4016C10.6417 14.5849 10.4292 14.7307 10.1875 14.8391C9.94583 14.9474 9.69167 15.0016 9.425 15.0016H7C6.71667 15.0016 6.47917 14.9057 6.2875 14.7141C6.09583 14.5224 6 14.2849 6 14.0016ZM8 13.0016H9.4L15.2 7.20156L14.5 6.50156L13.775 5.80156L8 11.5766V13.0016Z" fill="#929292" />
    </svg>
  ),
  markAsComplete: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="green"
      stroke-width="2"
      stroke-linecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" fill="none" stroke="green" />
      <polyline points="9 12 11 14 15 10" fill="none" stroke="green" />
    </svg>
  ),

  completeIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" fill="green" />
      <polyline points="9 12 11 14 15 10" fill="none" stroke="white" />
    </svg>
  ),
  activeEmail: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_1378_11173" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1378_11173)">
        <path
          d="M12 1.59625L20.7808 6.823C21.0038 6.968 21.1794 7.15875 21.3078 7.39525C21.4359 7.63175 21.5 7.88334 21.5 8.15V18.6923C21.5 19.1974 21.325 19.625 20.975 19.975C20.625 20.325 20.1974 20.5 19.6923 20.5H4.30775C3.80258 20.5 3.375 20.325 3.025 19.975C2.675 19.625 2.5 19.1974 2.5 18.6923V8.15C2.5 7.88334 2.56408 7.63175 2.69225 7.39525C2.82058 7.15875 2.99625 6.968 3.21925 6.823L12 1.59625ZM12 12.65L19.8 8L12 3.35L4.2 8L12 12.65ZM12 14.4038L4 9.623V18.6923C4 18.7821 4.02883 18.8558 4.0865 18.9135C4.14417 18.9712 4.21792 19 4.30775 19H19.6923C19.7821 19 19.8558 18.9712 19.9135 18.9135C19.9712 18.8558 20 18.7821 20 18.6923V9.623L12 14.4038Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  ),
  inActiveEmail: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_1378_11173" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1378_11173)">
        <path
          d="M12 1.59625L20.7808 6.823C21.0038 6.968 21.1794 7.15875 21.3078 7.39525C21.4359 7.63175 21.5 7.88334 21.5 8.15V18.6923C21.5 19.1974 21.325 19.625 20.975 19.975C20.625 20.325 20.1974 20.5 19.6923 20.5H4.30775C3.80258 20.5 3.375 20.325 3.025 19.975C2.675 19.625 2.5 19.1974 2.5 18.6923V8.15C2.5 7.88334 2.56408 7.63175 2.69225 7.39525C2.82058 7.15875 2.99625 6.968 3.21925 6.823L12 1.59625ZM12 12.65L19.8 8L12 3.35L4.2 8L12 12.65ZM12 14.4038L4 9.623V18.6923C4 18.7821 4.02883 18.8558 4.0865 18.9135C4.14417 18.9712 4.21792 19 4.30775 19H19.6923C19.7821 19 19.8558 18.9712 19.9135 18.9135C19.9712 18.8558 20 18.7821 20 18.6923V9.623L12 14.4038Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  ),
  activeEmailSent: (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <mask id="mask0_1378_11167" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
        <rect x="0.899414" y="0.68634" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1378_11167)">
        <path
          d="M12.8994 13.2441L4.89941 8.12859V18.3786C4.89941 18.4684 4.92825 18.5422 4.98591 18.5998C5.04358 18.6575 5.11733 18.6863 5.20716 18.6863H14.1494V20.1863H5.20716C4.702 20.1863 4.27441 20.0113 3.92441 19.6613C3.57441 19.3113 3.39941 18.8838 3.39941 18.3786V6.99409C3.39941 6.48892 3.57441 6.06134 3.92441 5.71134C4.27441 5.36134 4.702 5.18634 5.20716 5.18634H20.5917C21.0968 5.18634 21.5244 5.36134 21.8744 5.71134C22.2244 6.06134 22.3994 6.48892 22.3994 6.99409V13.9363H20.8994V8.12859L12.8994 13.2441ZM12.8994 11.6863L20.7457 6.68634H5.05316L12.8994 11.6863ZM19.7072 23.0806L18.6629 22.0363L20.4784 20.1863H15.9572V18.6863H20.4879L18.6379 16.8363L19.7072 15.7921L23.3514 19.4363L19.7072 23.0806ZM4.89941 8.12859V19.5228V13.9363V14.0593V6.68634V8.12859Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  ),
  inActiveEmailSend: (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <mask id="mask0_1378_11167" x="0" y="0" width="25" height="25">
        <rect x="0.899414" y="0.68634" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1378_11167)">
        <path
          d="M12.8994 13.2441L4.89941 8.12859V18.3786C4.89941 18.4684 4.92825 18.5422 4.98591 18.5998C5.04358 18.6575 5.11733 18.6863 5.20716 18.6863H14.1494V20.1863H5.20716C4.702 20.1863 4.27441 20.0113 3.92441 19.6613C3.57441 19.3113 3.39941 18.8838 3.39941 18.3786V6.99409C3.39941 6.48892 3.57441 6.06134 3.92441 5.71134C4.27441 5.36134 4.702 5.18634 5.20716 5.18634H20.5917C21.0968 5.18634 21.5244 5.36134 21.8744 5.71134C22.2244 6.06134 22.3994 6.48892 22.3994 6.99409V13.9363H20.8994V8.12859L12.8994 13.2441ZM12.8994 11.6863L20.7457 6.68634H5.05316L12.8994 11.6863ZM19.7072 23.0806L18.6629 22.0363L20.4784 20.1863H15.9572V18.6863H20.4879L18.6379 16.8363L19.7072 15.7921L23.3514 19.4363L19.7072 23.0806ZM4.89941 8.12859V19.5228V13.9363V14.0593V6.68634V8.12859Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  ),
  emailViewedActive: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_1378_11179" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1378_11179)">
        <path
          d="M12.7558 21.4595C12.6298 21.4865 12.5038 21.5 12.378 21.5H12C10.6858 21.5 9.45083 21.2507 8.295 20.752C7.13917 20.2533 6.13375 19.5766 5.27875 18.7218C4.42375 17.8669 3.74692 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74942 15.7035 3.24825C16.8597 3.74692 17.8653 4.42375 18.7205 5.27875C19.5757 6.13375 20.2528 7.13917 20.7518 8.295C21.2506 9.45083 21.5 10.6858 21.5 12V12.373C21.5 12.4973 21.4865 12.6218 21.4595 12.7463L20 12.3V12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20H12.3L12.7558 21.4595ZM20.1402 21.6443L15.6058 17.1L14.5193 20.3845L12 12L20.3845 14.5192L17.1 15.6058L21.6443 20.1402L20.1402 21.6443Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  ),
  emailViewedInActive: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_1378_11179" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1378_11179)">
        <path
          d="M12.7558 21.4595C12.6298 21.4865 12.5038 21.5 12.378 21.5H12C10.6858 21.5 9.45083 21.2507 8.295 20.752C7.13917 20.2533 6.13375 19.5766 5.27875 18.7218C4.42375 17.8669 3.74692 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74942 15.7035 3.24825C16.8597 3.74692 17.8653 4.42375 18.7205 5.27875C19.5757 6.13375 20.2528 7.13917 20.7518 8.295C21.2506 9.45083 21.5 10.6858 21.5 12V12.373C21.5 12.4973 21.4865 12.6218 21.4595 12.7463L20 12.3V12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20H12.3L12.7558 21.4595ZM20.1402 21.6443L15.6058 17.1L14.5193 20.3845L12 12L20.3845 14.5192L17.1 15.6058L21.6443 20.1402L20.1402 21.6443Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  ),
  emailReplyActive: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask
        id="mask0_1378_11191"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1378_11191)">
        <path
          d="M19 18.5V15C19 14.1025 18.6827 13.3365 18.048 12.702C17.4135 12.0673 16.6475 11.75 15.75 11.75H6.373L10.223 15.6L9.15375 16.6538L3.5 11L9.15375 5.34625L10.223 6.4L6.373 10.25H15.75C17.0628 10.25 18.1827 10.7135 19.1095 11.6405C20.0365 12.5673 20.5 13.6872 20.5 15V18.5H19Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  ),
  emailReplyInactive: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask
        id="mask0_1378_11191"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1378_11191)">
        <path
          d="M19 18.5V15C19 14.1025 18.6827 13.3365 18.048 12.702C17.4135 12.0673 16.6475 11.75 15.75 11.75H6.373L10.223 15.6L9.15375 16.6538L3.5 11L9.15375 5.34625L10.223 6.4L6.373 10.25H15.75C17.0628 10.25 18.1827 10.7135 19.1095 11.6405C20.0365 12.5673 20.5 13.6872 20.5 15V18.5H19Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  ),
  sentActiveEmailSvgIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_364_1315" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_364_1315)">
        <path
          d="M12 12.5577L4 7.44225V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18H13.25V19.5H4.30775C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V13.25H20V7.44225L12 12.5577ZM12 11L19.8463 6H4.15375L12 11ZM18.8078 22.3943L17.7635 21.35L19.579 19.5H15.0578V18H19.5885L17.7385 16.15L18.8078 15.1058L22.452 18.75L18.8078 22.3943ZM4 7.44225V18.8365V13.25V13.373V6V7.44225Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  ),
  sentInactiveEmailSvgIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_364_1315" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_364_1315)">
        <path
          d="M12 12.5577L4 7.44225V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18H13.25V19.5H4.30775C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V13.25H20V7.44225L12 12.5577ZM12 11L19.8463 6H4.15375L12 11ZM18.8078 22.3943L17.7635 21.35L19.579 19.5H15.0578V18H19.5885L17.7385 16.15L18.8078 15.1058L22.452 18.75L18.8078 22.3943ZM4 7.44225V18.8365V13.25V13.373V6V7.44225Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  ),
  bounceActiveSvgIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <mask id="mask0_366_1340" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
        <rect x="0.191406" y="0.95459" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_366_1340)">
        <path
          d="M15.9107 22.5891L12.0069 18.6853L13.0607 17.6316L15.9107 20.4816L21.5799 14.8123L22.6337 15.8661L15.9107 22.5891ZM12.1914 11.9546L20.0377 6.95459H4.34516L12.1914 11.9546ZM12.1914 13.5123L4.19141 8.39684V18.6468C4.19141 18.7367 4.22024 18.8104 4.27791 18.8681C4.33557 18.9258 4.40932 18.9546 4.49916 18.9546H9.46641L10.9664 20.4546H4.49916C3.99399 20.4546 3.56641 20.2796 3.21641 19.9296C2.86641 19.5796 2.69141 19.152 2.69141 18.6468V7.26234C2.69141 6.75717 2.86641 6.32959 3.21641 5.97959C3.56641 5.62959 3.99399 5.45459 4.49916 5.45459H19.8837C20.3888 5.45459 20.8164 5.62959 21.1664 5.97959C21.5164 6.32959 21.6914 6.75717 21.6914 7.26234V11.9008L20.1914 13.4008V8.39684L12.1914 13.5123Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  ),
  bounceInactiveSvgIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_364_1321" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_364_1321)">
        <path
          d="M12.048 17.0694L5 10.0211V14.9521H3.5V7.45215H11V8.95215H6.05375L12.048 14.9464L19.4557 7.53865L20.5095 8.6079L12.048 17.0694Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  ),
  openActiveSvgIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_364_1327" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_364_1327)">
        <path
          d="M12 1.59619L20.7808 6.82294C21.0038 6.96794 21.1794 7.15869 21.3078 7.39519C21.4359 7.63169 21.5 7.88328 21.5 8.14994V18.6922C21.5 19.1974 21.325 19.6249 20.975 19.9749C20.625 20.3249 20.1974 20.4999 19.6923 20.4999H4.30775C3.80258 20.4999 3.375 20.3249 3.025 19.9749C2.675 19.6249 2.5 19.1974 2.5 18.6922V8.14994C2.5 7.88328 2.56408 7.63169 2.69225 7.39519C2.82058 7.15869 2.99625 6.96794 3.21925 6.82294L12 1.59619ZM12 12.6499L19.8 7.99994L12 3.34994L4.2 7.99994L12 12.6499ZM12 14.4037L4 9.62294V18.6922C4 18.782 4.02883 18.8558 4.0865 18.9134C4.14417 18.9711 4.21792 18.9999 4.30775 18.9999H19.6923C19.7821 18.9999 19.8558 18.9711 19.9135 18.9134C19.9712 18.8558 20 18.782 20 18.6922V9.62294L12 14.4037Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  ),
  openInactiveSvgIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_364_1327" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_364_1327)">
        <path
          d="M12 1.59619L20.7808 6.82294C21.0038 6.96794 21.1794 7.15869 21.3078 7.39519C21.4359 7.63169 21.5 7.88328 21.5 8.14994V18.6922C21.5 19.1974 21.325 19.6249 20.975 19.9749C20.625 20.3249 20.1974 20.4999 19.6923 20.4999H4.30775C3.80258 20.4999 3.375 20.3249 3.025 19.9749C2.675 19.6249 2.5 19.1974 2.5 18.6922V8.14994C2.5 7.88328 2.56408 7.63169 2.69225 7.39519C2.82058 7.15869 2.99625 6.96794 3.21925 6.82294L12 1.59619ZM12 12.6499L19.8 7.99994L12 3.34994L4.2 7.99994L12 12.6499ZM12 14.4037L4 9.62294V18.6922C4 18.782 4.02883 18.8558 4.0865 18.9134C4.14417 18.9711 4.21792 18.9999 4.30775 18.9999H19.6923C19.7821 18.9999 19.8558 18.9711 19.9135 18.9134C19.9712 18.8558 20 18.782 20 18.6922V9.62294L12 14.4037Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  ),
  UploadIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="32"
      viewBox="0 0 44 32"
      fill="none"
    >
      <path
        d="M11 32C7.96667 32 5.375 30.95 3.225 28.85C1.075 26.75 0 24.1833 0 21.15C0 18.55 0.783333 16.2333 2.35 14.2C3.91667 12.1667 5.96667 10.8667 8.5 10.3C9.33333 7.23333 11 4.75 13.5 2.85C16 0.95 18.8333 0 22 0C25.9 0 29.2083 1.35833 31.925 4.075C34.6417 6.79167 36 10.1 36 14C38.3 14.2667 40.2083 15.2583 41.725 16.975C43.2417 18.6917 44 20.7 44 23C44 25.5 43.125 27.625 41.375 29.375C39.625 31.125 37.5 32 35 32H24V17.7L25.8 19.45C26.1667 19.8167 26.625 20 27.175 20C27.725 20 28.2 19.8 28.6 19.4C28.9667 19.0333 29.15 18.5667 29.15 18C29.15 17.4333 28.9667 16.9667 28.6 16.6L23.4 11.4C23 11 22.5333 10.8 22 10.8C21.4667 10.8 21 11 20.6 11.4L15.4 16.6C15.0333 16.9667 14.8417 17.425 14.825 17.975C14.8083 18.525 15 19 15.4 19.4C15.7667 19.7667 16.225 19.9583 16.775 19.975C17.325 19.9917 17.8 19.8167 18.2 19.45L20 17.7V32H11Z"
        fill=""
      />
    </svg>
  ),
  threedot: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      class="bi bi-three-dots-vertical"
    >
      <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
    </svg>
  ),
  Cross: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 25 25"
      version="1.1"
    >
      <title>cross</title>
      <desc>Created with Sketch Beta.</desc>
      <defs></defs>
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Icon-Set-Filled"
          transform="translate(-469.000000, -1041.000000)"
          fill="#d02b20"
        >
          <path
            d="M487.148,1053.48 L492.813,1047.82 C494.376,1046.26 494.376,1043.72 492.813,1042.16 C491.248,1040.59 488.712,1040.59 487.148,1042.16 L481.484,1047.82 L475.82,1042.16 C474.257,1040.59 471.721,1040.59 470.156,1042.16 C468.593,1043.72 468.593,1046.26 470.156,1047.82 L475.82,1053.48 L470.156,1059.15 C468.593,1060.71 468.593,1063.25 470.156,1064.81 C471.721,1066.38 474.257,1066.38 475.82,1064.81 L481.484,1059.15 L487.148,1064.81 C488.712,1066.38 491.248,1066.38 492.813,1064.81 C494.376,1063.25 494.376,1060.71 492.813,1059.15 L487.148,1053.48"
            id="cross"
          ></path>
        </g>
      </g>
    </svg>
  ),
  KeyIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16" height="16" fill="currentColor"><path d="M20 2a10.01 10.01 0 0 0-9.511 13.098l-7.196 7.195A1 1 0 0 0 3 23v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-2h2a1 1 0 0 0 1-1v-2h2a1 1 0 0 0 .707-.293l1.195-1.196A10 10 0 1 0 20 2m2.5 9.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4"></path></svg>
  )
};

export const exportbutton = `
<button class='moreinfobutton'>
More Info
</button>`;

export const exportdiv = `<div>
<svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="none">
<g filter="url(#filter0_d_4118_60845)">
  <rect
    x="10"
    y="10"
    width="38"
    height="38"
    rx="19"
    fill="white"
    fill-opacity="0.5"
    shape-rendering="crispEdges"
  />
  <circle cx="29" cy="29" r="11" fill="#88A4EA" fill-opacity="0.95" />
  <rect
    x="10.5"
    y="10.5"
    width="37"
    height="37"
    rx="18.5"
    stroke="#E6E6E6"
    shape-rendering="crispEdges"
  />
</g>
<defs>
  <filter
    id="filter0_d_4118_60845"
    x="0"
    y="0"
    width="58"
    height="58"
    filterUnits="userSpaceOnUse"
    colorInterpolationFilters="sRGB"
  >
    <feFlood flood-opacity="0" result="BackgroundImageFix" />
    <feColorMatrix
      in="SourceAlpha"
      type="matrix"
      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      result="hardAlpha"
    />
    <feOffset />
    <feGaussianBlur stdDeviation="5" />
    <feComposite in2="hardAlpha" operator="out" />
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4118_60845" />
    <feBlend
      mode="normal"
      in="SourceGraphic"
      in2="effect1_dropShadow_4118_60845"
      result="shape"
    />
  </filter>
</defs>
</svg>
</div>`;
